import { maskAccountNumber } from './maskAccountNumber'

const SENSITIVE_KEY_PATTERN = /account.?number|routing.?number|accountNumber|routingNumber/i

/**
 * Deep copy of `value` with every account/routing number (matched by key, any case or snake/camel
 * form) replaced by its masked form, for raw JSON previews. The input is never mutated.
 */
export const redactSensitiveJson = (value: unknown): unknown => {
  if (Array.isArray(value)) {
    return value.map((item) => {
      return redactSensitiveJson(item)
    })
  }

  if (value !== null && typeof value === 'object') {
    return Object.entries(value as Record<string, unknown>).reduce<Record<string, unknown>>(
      (copy, [key, entry]) => {
        const isSensitive =
          SENSITIVE_KEY_PATTERN.test(key) &&
          (typeof entry === 'string' || typeof entry === 'number')

        copy[key] = isSensitive ? maskAccountNumber(String(entry)) : redactSensitiveJson(entry)

        return copy
      },
      {},
    )
  }

  return value
}
